<template>
    <div class="container">
      <h1>首页内容展示</h1>
    </div>
</template>

<script>
    export default {
        name: "Home"
    }
</script>

<style scoped>
  .container{
    background: #fff;
    min-height: 800px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue